import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NumberField, Radio } from 'enova-frontend-components';

import { camelCasify, kebabCasify } from '../../../../../utils/navigation';
import { WindowSpecType } from '../../../utils/window';
import CollapsibleRegField from '../../../collapsibleRegField/collapsibleRegField';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { WindowType as TypeOfWindow } from '../../utils';

interface UValueProps {
  onChange: (value: number | undefined) => void;
  type: TypeOfWindow;
  uverdi?: number | undefined;
  windowSpecType: WindowSpecType | null;
}

export const UValue: FC<UValueProps> = ({ onChange, type, uverdi, windowSpecType }) => {
  const { t } = useTranslation();
  const { xsScreen } = useMediaQuery();

  return (
    <CollapsibleRegField open={windowSpecType === WindowSpecType.U_VALUE} transparent={type === 'roof'}>
      <Radio
        width={xsScreen ? 'fullWidth' : 'auto'}
        helperText={t('register.windows.knownUvalue.helperText')}
        className="mb-2"
        label={t(`register.window.${camelCasify(WindowSpecType.U_VALUE)}`)}
        value={WindowSpecType.U_VALUE}
      />

      <CollapsibleRegField.Collapse>
        <NumberField
          autoComplete
          required
          label={t(`register.window.${camelCasify(WindowSpecType.U_VALUE)}.label`)}
          name={kebabCasify(WindowSpecType.U_VALUE)}
          onValueChange={({ floatValue }) => onChange(floatValue)}
          value={uverdi}
          suffix={t('suffix.uvalue')}
        />
      </CollapsibleRegField.Collapse>
    </CollapsibleRegField>
  );
};
